
/**
 * 강의 콘텐츠 지원 플랫폼
 */
export type GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItemPlatformSupport = typeof GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItemPlatformSupport[keyof typeof GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
  UNKNOWN: 'UNKNOWN',
} as const;
